<template>
  <div class="edit-ubicazione-padre" style="padding: 20px">
    <v-card>
      <v-toolbar class="indigo white--text" dense primary-title>
        <v-toolbar-title>Famiglie Articoli Ubicazioni</v-toolbar-title>

        <v-spacer></v-spacer>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" small elevation="1" @click="nuovaFamiglia">
              <v-icon color="#1a80b6"> mdi-plus </v-icon>
            </v-btn>
          </template>
          <span>Crea Famiglia</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              small
              elevation="1"
              class="ml-10"
              @click="salvaUbicazione"
            >
              <v-icon color="success"> mdi-floppy </v-icon>
            </v-btn>
          </template>
          <span>Salva Ubicazione</span>
        </v-tooltip>

        <v-spacer></v-spacer>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              small
              elevation="1"
              @click="show_filter = !show_filter"
            >
              <v-icon v-if="!show_filter" color="purple"> mdi-filter </v-icon>
              <v-icon v-if="show_filter" color="purple">
                mdi-filter-off
              </v-icon>
            </v-btn>
          </template>
          <span>Filtri</span>
        </v-tooltip>

        <v-spacer></v-spacer>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              small
              elevation="1"
              @click="
                $router.push({
                  name: 'edit-magazzino',
                  params: { id: idMagazzino, duplicateId: duplicateId },
                })
              "
            >
              <v-icon class="error--text"> mdi-keyboard-backspace </v-icon>
            </v-btn>
          </template>
          <span>Indietro</span>
        </v-tooltip>
      </v-toolbar>

      <v-progress-linear
        indeterminate
        color="cyan"
        v-if="loading"
        id="progress"
      >
      </v-progress-linear>

      <v-card-text>
        <v-row v-if="show_filter">
          <v-col>
            <v-autocomplete
              label="Codice Famiglia"
              dense
              outlined
              v-model="filtroCod"
              :items="codici"
            >
            </v-autocomplete>
          </v-col>
          <v-col>
            <v-autocomplete
              label="Descrizione Famiglia"
              dense
              outlined
              v-model="filtroDes"
              :items="descrizioni"
            >
            </v-autocomplete>
          </v-col>
          <v-col>
            <v-autocomplete
              label="Codice Sotto Famiglia"
              dense
              outlined
              v-model="filtroCodSot"
              :items="codiciSot"
            >
            </v-autocomplete>
          </v-col>
          <v-col>
            <v-autocomplete
              label="Descrizione Sotto Famigia"
              dense
              outlined
              v-model="filtroDesSot"
              :items="descrizioniSot"
            >
            </v-autocomplete>
          </v-col>
        </v-row>

        <v-data-table
          :items="
            tabella.filter(
              (e) =>
                e.validita == 1 &&
                (filtroCod == 'Tutti' || filtroCod == e.cod) &&
                (filtroDes == 'Tutti' || filtroDes == e.des) &&
                (filtroCodSot == 'Tutti' || filtroCodSot == e.cod_sotto) &&
                (filtroDesSot == 'Tutti' || filtroDesSot == e.des_sotto)
            )
          "
          :headers="headers"
        >
          <template v-slot:[`item.modifica`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  small
                  elevation="1"
                  class="ma-1"
                  @click="modificaFamiglia(item)"
                >
                  <v-icon color="#1a80b6"> mdi-pencil </v-icon>
                </v-btn>
              </template>
              <span>Modifica</span>
            </v-tooltip>
            
          </template>

          <template v-slot:[`item.divieto`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  small
                  elevation="1"
                  class="ma-1"
                  @click="forbid(item)"
                >
                  <v-icon :color="item.divieto ? 'error' : 'success'"> {{item.divieto ? 'mdi-cancel' : 'mdi-thumb-up'}} </v-icon>
                </v-btn>
              </template>
              <span>Proibire</span>
            </v-tooltip>
          </template>

          <template v-slot:[`item.elimina`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  small
                  elevation="1"
                  @click="deleteFamiglia(item)"
                >
                  <v-icon class="error--text">mdi-close</v-icon>
                </v-btn>
              </template>
              <span>Elimina</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-dialog v-model="dialogNew" width="800">
      <v-card>
        <v-toolbar class="indigo white--text" dense>
          <v-toolbar-title class="white--text">
            {{ !modify ? "Nuova Famiglia" : "Modifica Famiglia" }}
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" small @click="saveFamiglia">
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Inserisci</span>
          </v-tooltip>

          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" @click="dialogNew = false" small>
                <v-icon class="error--text"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>

        <v-container fluid>
          <v-row dense>
            <v-col>
              <v-autocomplete
                label="Famiglia"
                dense
                outlined
                v-model="tempFamiglia"
                :items="famiglie"
                item-text="des"
                return-object
              >
              </v-autocomplete>
            </v-col>

            <v-col>
              <v-autocomplete
                label="Sotto Famiglia"
                dense
                outlined
                v-model="tempSottoFamiglia"
                :items="
                  sottoFamiglie.filter(
                    (e) => e.val_int == tempFamiglia.id_tabella
                  )
                "
                item-text="des"
                return-object
              >
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
    <SnackbarQV ref="SnackbarQV" />
  </div>
</template>

<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
export default {
  name: "editUbicazionePadre",
  props: ["id", "idMagazzino", "duplicateId"],
  components: {
    SnackbarQV,
  },
  data() {
    return {
      nextTempId: 1,
      modify: false,
      tempItem: null,
      tempFamiglia: { id_tabella: 0 },
      tempSottoFamiglia: { val_int: 0 },
      loading: false,
      show_filter: false,
      dialogNew: false,
      filtroCod: "Tutti",
      filtroDes: "Tutti",
      filtroCodSot: "Tutti",
      filtroDesSot: "Tutti",
      tabella: [],

      codici: [],
      descrizioni: [],
      codiciSot: [],
      descrizioniSot: [],
      famiglie: [],
      sottoFamiglie: [],
      headers: [
        {
          text: "Modifica",
          value: "modifica",
        },
        {
          text: "Permesso",
          value: "divieto",
        },
        {
          text: "Codice Famiglia",
          value: "cod",
        },
        {
          text: "Descrizione Famiglia",
          value: "des",
        },
        {
          text: "Codice Sotto Famiglia",
          value: "cod_sotto",
        },
        {
          text: "Descrizione Sotto Famiglia",
          value: "des_sotto",
        },
        {
          text: "Elimina",
          value: "elimina",
        },
      ],
    };
  },
  async mounted() {
    this.loading = true;
    await this.getFamiglie();
    await this.getUbicazione();
    this.populateFilters();
    this.loading = false;
  },
  methods: {
    async getUbicazione() {
      let requestUbicazione = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getarticoliubicazione",
          id_ubicazione: this.id,
          token: localStorage.user_token,
        },
      };

      await this.$store.dispatch("api", requestUbicazione).then(async (res) => {
        if (res.status == 200) {
          this.tabella = Array.from(res.data.result.articoli);
          this.tabella.forEach((e) => {
            e.des = "";
            e.cod = "";
            e.cod_sotto = "";
            e.des_sotto = "";
            (e.tempId = -1),
              this.famiglie.forEach((f) => {
                if (e.id_famiglia == f.id_tabella) {
                  e.des = f.des;
                  e.cod = f.cod;
                }
              });
            this.sottoFamiglie.forEach((f) => {
              if (e.id_sotto_famiglia == f.id_tabella) {
                e.des_sotto = f.des;
                e.cod_sotto = f.cod;
              }
            });
          });
        }
      });
    },
    populateFilters() {
      this.codici = [];
      this.descrizioni = [];
      this.codiciSot = [];
      this.descrizioniSot = [];
      this.tabella.forEach((e) => {
        if (e.validita == 1) {
          this.famiglie.forEach((f) => {
            if (e.id_famiglia == f.id_tabella) {
              if (!this.codici.includes(f.cod) && f.cod != null) {
                this.codici.push(f.cod);
              }
              if (!this.descrizioni.includes(f.des) && f.des != null) {
                this.descrizioni.push(f.des);
              }
            }
          });
          this.sottoFamiglie.forEach((f) => {
            if (e.id_sotto_famiglia == f.id_tabella) {
              if (!this.codiciSot.includes(f.cod) && f.cod != null) {
                this.codiciSot.push(f.cod);
              }
              if (!this.descrizioniSot.includes(f.des) && f.des != null) {
                this.descrizioniSot.push(f.des);
              }
            }
          });
        }
      });
      this.codici.unshift("Tutti");
      this.descrizioni.unshift("Tutti");
      this.codiciSot.unshift("Tutti");
      this.descrizioniSot.unshift("Tutti");
    },
    async getFamiglie() {
      let requestFamiglie = {
        controller: "Global",
        method: "POST",
        richiesta: {
          action: "gettabella",
          token: localStorage.getItem("user_token"),
          tipo: "FAMIGLIA",
          filter: "validita = 1",
        },
      };
      await this.$store.dispatch("api", requestFamiglie).then((res) => {
        if (res.status === 200) {
          this.famiglie = Array.from(res.data);
        }
      });

      let requestSottoFamiglie = {
        controller: "Global",
        method: "POST",
        richiesta: {
          action: "gettabella",
          token: localStorage.getItem("user_token"),
          tipo: "SOTTO_FAMIGLIA",
          filter: "validita = 1",
        },
      };
      await this.$store.dispatch("api", requestSottoFamiglie).then((res) => {
        if (res.status === 200) {
          this.sottoFamiglie = Array.from(res.data);
        }
      });
    },
    nuovaFamiglia() {
      this.modify = false;
      this.dialogNew = true;
    },
    saveFamiglia() {
      if (!this.modify) {
        this.tabella.push({
          id_articolo_ubicazione: -1,
          id_magazzino_ubicazione: this.id,
          id_famiglia: this.tempFamiglia.id_tabella,
          id_sotto_famiglia: this.tempSottoFamiglia.id_tabella,
          des: this.tempFamiglia.des,
          cod: this.tempFamiglia.cod,
          cod_sotto: this.tempSottoFamiglia.cod,
          des_sotto: this.tempSottoFamiglia.des,
          validita: 1,
          tempId: this.nextTempId,
          divieto: false,
        });
        this.nextTempId++;
      } else {
        this.tempItem.id_famiglia = this.tempFamiglia.id_tabella;
        this.tempItem.id_sotto_famiglia = this.tempSottoFamiglia.id_tabella;
        this.tempItem.des = this.tempFamiglia.des;
        this.tempItem.cod = this.tempFamiglia.cod;
        this.tempItem.cod_sotto = this.tempSottoFamiglia.cod;
        this.tempItem.des_sotto = this.tempSottoFamiglia.des;
      }
      this.dialogNew = false;
      this.populateFilters();
    },
    forbid(item) {
      item.divieto = !item.divieto;
    },
    modificaFamiglia(item) {
      this.tempItem = item;
      this.tempFamiglia.id_tabella = this.tempItem.id_famiglia;
      this.tempSottoFamiglia.id_tabella = this.tempItem.id_sotto_famiglia;
      this.tempFamiglia.des = this.tempItem.des;
      this.tempFamiglia.cod = this.tempItem.cod;
      this.tempSottoFamiglia.cod = this.tempItem.cod_sotto;
      this.tempSottoFamiglia.des = this.tempItem.des_sotto;
      this.modify = true;
      this.dialogNew = true;
    },
    deleteFamiglia(item) {
      if (item.id_articolo_ubicazione == -1) {
        for (let i = 0; i < this.tabella.length; i++) {
          const e = this.tabella[i];
          if (e.tempId == item.tempId) {
            this.tabella.splice(i, 1);
            break;
          }
        }
      } else {
        item.validita = 0;
      }
      this.populateFilters();
    },
    async salvaUbicazione() {
      this.loading = true;

      let request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setarticoliubicazione",
          ubicazione: this.tabella,
          token: localStorage.user_token,
        },
      };

      await this.$store.dispatch("api", request).then(async (res) => {
        if (res.status == 200) {
          this.$refs.SnackbarQV.print(
            "success",
            "Ubicazione salvato con successo"
          );
        } else {
          this.$refs.SnackbarQV.print("error", "Ubicazione non salvato");
        }
      });
      await this.getUbicazione();
      this.loading = false;
    },
  },
};
</script>